import { render, staticRenderFns } from "./preregistro.vue?vue&type=template&id=8c0ede72&scoped=true"
import script from "./preregistro.vue?vue&type=script&lang=js"
export * from "./preregistro.vue?vue&type=script&lang=js"
import style0 from "./preregistro.vue?vue&type=style&index=0&id=8c0ede72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0ede72",
  null
  
)

export default component.exports